import './shim';
import 'react-native-get-random-values';
import * as bip39 from 'bip39';

export default bip39;
